import { cn } from "@/lib/utils";

const TONES = {
  green: "bg-patria-green/12 text-patria-greenDeep ring-1 ring-patria-green/25",
  amber: "bg-patria-terracotta/12 text-patria-terracottaDeep ring-1 ring-patria-terracotta/25",
  red: "bg-patria-terracottaDeep/15 text-patria-terracottaDeep ring-1 ring-patria-terracottaDeep/35",
  neutral: "bg-patria-muted/12 text-patria-muted ring-1 ring-patria-muted/25",
};

export function StatusChip({ label, tone = "neutral", className, testId }) {
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium whitespace-nowrap",
        TONES[tone] || TONES.neutral,
        className
      )}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full",
        tone === "green" && "bg-patria-green",
        tone === "amber" && "bg-patria-terracotta",
        tone === "red" && "bg-patria-terracottaDeep",
        tone === "neutral" && "bg-patria-muted"
      )} />
      {label}
    </span>
  );
}
